export const styles = {
  "header-container": [
    "text-black-me",
    "hover:text-yellow-me",
    "bg-transparent",
    "py-5",
    "px-8",
    "pl-3",
    "fixed",
    "z-20",
    "cursor-pointer",
    "transition-colors",
    "duration-100",
  ].join(" "),
  svg: ["cursor-pointer", "fill-current"].join(" "),
  active_: ["active-toggle-menu"].join(" "),
  in_: ["animate-menu-in"].join(" "),
  out_: ["animate-menu-out"].join(" "),
};
